module.exports = __webpack_public_path__ + "img/cinema_5.76bcada8.jpg";